.container {
  display: flex;
}

.search {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.assetsList {
  flex-grow: 1;
  margin: 0 calc(-1 * var(--space-xs));
}

.hint {
  display: block;
  margin-top: var(--space-xs);
  color: var(--color-accent-1);
  font-size: 0.8em;
}
